import React, { useState } from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";

import classImg from "../images/how_many_class.png"; // background image

const Step9 = () => {
  const student = JSON.parse(localStorage.getItem("student"));
  const [classes, setClasses] = useState("");

  const handleNext = async () => {
    if (classes.trim() === "" || isNaN(classes)) {
      alert("Please enter a valid number.");
      return;
    }

    try {
      const response = await fetch(
         `http://localhost:3000/api/student-demography/${student.student_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            how_many_class: Number(classes),
            current_step: "done", // <--- FINAL STEP TRACKER
          }),
        }
      );

      if (!response.ok) {
        alert("Failed to save your data.");
        return;
      }

      // Update local storage
      const updatedStudent = {
        ...student,
        how_many_class: Number(classes),
        current_step: "done",
      };
      localStorage.setItem("student", JSON.stringify(updatedStudent));

      // NEXT PAGE
      window.location.href = "/Appreciate";

    } catch (err) {
      console.error("Error updating:", err);
      alert("Server error");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-blue-900 text-white relative">

      {/* Progress Bar */}
      <div className="w-full max-w-2xl mt-6 z-20">
        <ProgressBar step={9} />
      </div>

      {/* IMAGE + INPUT */}
      <div className="relative mt-6">

        {/* Background Image */}
        <img 
          src={classImg}
          alt="How many classes"
          className="w-[340px] md:w-[480px] rounded-xl shadow-xl border-4 border-blue-700"
        />

        {/* Yellow Oval Input (same as abang punya) */}
        <input
          type="number"
          value={classes}
          onChange={(e) => setClasses(e.target.value)}
          className="
            absolute 
            left-[50%] md:left-[52%]
            -translate-x-1/2
            top-[100px] md:top-[145px]
            w-28 md:w-36
            text-center text-xl font-bold text-blue-900
            bg-yellow-300 rounded-full py-2.5
            shadow-md outline-none
          "
        />

      </div>

      {/* NEXT BUTTON */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleNext}
        className="
          mt-6
          bg-yellow-300 text-blue-900 font-bold
          px-10 py-3 rounded-2xl shadow-md
          text-lg flex items-center gap-2
        "
      >
        Next ➤
      </motion.button>

      {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step9;
